import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global response error handling: prevent uncaught promise rejections
// from bubbling to CRA's error overlay. Individual callers should still
// use try/catch or .catch() to react to specific errors (401, 4xx, etc.).
http.interceptors.response.use(
  (r) => r,
  (error) => {
    // Attach a normalized status/message but leave rejection intact for callers
    // that DO handle it. Callers without a .catch() will still receive the
    // rejection but the browser marks it handled via the global handler below.
    return Promise.reject(error);
  }
);

// Silence unhandled promise rejection overlay for expected auth 401s.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const status = event.reason?.response?.status;
    // Silently swallow expected 401 (session expired / anonymous fetch to protected)
    // and 403 (role mismatch) so they don't trigger the red dev overlay.
    if (status === 401 || status === 403) {
      event.preventDefault();
    }
  });
}

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const currency = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(n || 0));

export const STATUS_CONFIG = {
  pendiente: { color: "#F59E0B", label: "Pendiente" },
  confirmado: { color: "#3B82F6", label: "Confirmado" }, // legacy
  en_diseño: { color: "#8B5CF6", label: "En Diseño" },   // legacy
  en_produccion: { color: "#EC4899", label: "En Producción" },
  listo: { color: "#10B981", label: "Listo" },
  enviado: { color: "#06B6D4", label: "Enviado" },
  entregado: { color: "#22C55E", label: "Entregado" },
  cancelado: { color: "#71717A", label: "Cancelado" },
};

export const STATUS_ORDER = [
  "pendiente",
  "en_produccion",
  "listo",
  "enviado",
  "entregado",
];
